import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  // filterBy: "",
}

const commonFilterSlice = createSlice({
  name: 'commonFilter',
  initialState,
  reducers: {
    setFilter: (state, action) => {
      state[action.payload.property] = action.payload.value
    },
  },
})

export const { setFilter } = commonFilterSlice.actions
export default commonFilterSlice.reducer
